import TableBodyRowsSkeleton from "./TableBodyRowsSkeleton";

export default TableBodyRowsSkeleton;
